import {
  ContentBox,
  SoilBar,
  Typography,
  UsdcBar,
} from "../../../../../components";
import { config } from "../../../../../config";
import { formatBigNumber } from "../../../../../utils";
import { ClaimAllRewards } from "./ClaimAllRewards";
import { useFetchAmountOfRewards } from "./useFetchAmountOfRewards";
import * as S from "./UserRewards.styled";
import { RewardsBoxWithTitle } from "../UserInvestmentsInfo.styled";
import { useAppSelector } from "../../../../../redux";
import { EarnedBar } from "../../../../../components/EarnedBar/EarnedBar";

export const UserRewards = () => {
  const { usdcRewards, soilRewards, lastUserRewards, refreshRewards } =
    useFetchAmountOfRewards();

  const { isLogged } = useAppSelector((state) => state.user);

  return (
    <RewardsBoxWithTitle>
      <Typography.IngraSubtitle fontWeight={600}>
        REWARDS EARNED
      </Typography.IngraSubtitle>
      <ContentBox>
        <S.ProfitWrapper>
          <UsdcBar
            value={
              usdcRewards
                ? formatBigNumber(usdcRewards, config.USDC_TOKEN_DECIMALS)
                : "-"
            }
            bordered
          />
          <EarnedBar
            value={
              lastUserRewards?.usdc
                ? formatBigNumber(
                    lastUserRewards.usdc,
                    config.USDC_TOKEN_DECIMALS
                  )
                : "-"
            }
            label={config.STABLE_TOKEN}
          />
        </S.ProfitWrapper>
        <S.ProfitWrapper>
          <SoilBar
            value={
              soilRewards
                ? formatBigNumber(soilRewards, config.SOIL_TOKEN_DECIMALS)
                : "-"
            }
            bordered
          />
          <EarnedBar
            value={
              lastUserRewards?.soil
                ? formatBigNumber(
                    lastUserRewards.soil,
                    config.SOIL_TOKEN_DECIMALS
                  )
                : "-"
            }
            label={config.PROJECT_TOKEN}
          />
        </S.ProfitWrapper>
      </ContentBox>
      {Number(usdcRewards) > 0 || (Number(soilRewards) > 0 && isLogged) ? (
        <ClaimAllRewards onClaimSuccess={refreshRewards} />
      ) : null}
    </RewardsBoxWithTitle>
  );
};
